import { Button, Checkbox, Col, Input, message, Modal, Row, Select, Space } from "antd"
import React, { useEffect, useState } from "react";
import { filterOption } from "../../../utils/funcHelper";
import { STATUS_ORDER } from "../../../constants/constants";

const ModalUpdatePrinterOrders = ({ visible, onCancel, onSave, printers }) => {
    const [supplier_id, setSupplierId] = useState();
    const [isChecked, setIsChecked] = useState(false);
    const [status, setStatus] = useState(null);

    const handleSave = () => {
        if (!supplier_id && isChecked) {
            message.error('Vui lòng chọn nhà in để xuất excel');
            return;
        }
        if (!supplier_id && !status) {
            message.error('Vui lòng chọn nhà in hoặc trạng thái đơn hàng để cập nhật');
            return;
        }
        onSave({ supplier_id: supplier_id, isExport: isChecked, status: status });
        onCancel();
    }

    useEffect(() => {
        setIsChecked(false);
        setSupplierId(null);
        setStatus(null);
    }, [visible])

    return (
        <Modal
            title={'Cập nhật nhà in, trạng thái cho các đơn hàng'}
            open={visible}
            onCancel={onCancel}
            width={'50%'}
            footer={null}
        >
            <Row gutter={16} style={{ marginBottom: 10 }}>
                <Col span={12}>
                    <Select
                        showSearch
                        allowClear
                        value={supplier_id}
                        onChange={(value) => setSupplierId(value)}
                        placeholder={'Chọn nhà in'}
                        style={{ width: '100%', height: 40 }}
                        defaultActiveFirstOption={false}
                        filterOption={filterOption}
                        notFoundContent={null}
                        options={printers?.map((item, index) => ({ value: item?.id, label: `${index + 1}. ${item?.name}` }))}
                    />

                </Col>
                <Col span={12}>
                    <Select
                        showSearch
                        allowClear
                        value={status}
                        onChange={(value) => setStatus(value)}
                        placeholder={'Trạng thái đơn hàng'}
                        style={{ width: '100%', height: 40 }}
                        defaultActiveFirstOption={false}
                        filterOption={filterOption}
                        notFoundContent={null}
                        options={STATUS_ORDER}
                    />

                </Col>


            </Row>
            <Row justify={'start'}>
                <Checkbox
                    style={{ marginTop: 10 }}
                    checked={isChecked}
                    onChange={(value) => setIsChecked(!isChecked)}
                >
                    Xuất excel các đơn hàng này
                </Checkbox>
            </Row>
            <Row gutter={16} justify={'end'}>
                <Space>
                    <Button onClick={onCancel}>
                        Cancel
                    </Button>
                    <Button type="primary" onClick={handleSave}>
                        Save
                    </Button>
                </Space>
            </Row>
        </Modal>
    )
}
export default React.memo(ModalUpdatePrinterOrders);

